<template>
    <div class="card-list wallet-list" style="position: relative;background-color: white;width: calc(100% - 20px);margin: 9px;border: 1px solid #c0c0c0;margin-bottom: 10px;float: left;">
        <header>
            <p>Cards in <span style="font-weight: bold;">{{ wallet.title }}</span></p>
            <div class="list-icons">
                <p class="btn sm" v-if="wallet.title != 'All Cards'" style="line-height: 2;margin-top:2px;width: 150px;" @click="addCardsToWallet(wallet)">add / remove cards</p>
                <p class="btn sm" v-if="wallet.title == 'All Cards'" style="line-height: 2;margin-top: 2px;" @click="$router.push('/carddesigner')">new card</p>
                <img src="/ICONList.png" @click="ICONList()" />
                <img src="/ItemList.png" @click="ItemList()"/>
            </div>
        </header>
        
        <div>
            <div class="list-search" :style="{ 'grid-template-columns': list.grid }">
                <div class="item-search" v-for="field in list.fields" @keyup="search" @change="search">
                    <p :class="['order',field.order || '']" @click="order(field)"></p><p>{{ field.title }}</p>
                    <input v-model="field.value" />
                </div>
            </div>
            <div class="list-items" v-if="!showICONS">
                <div v-if="Array.isArray(wallet.cards)" v-for="(item,x) in wallet.cards.filter(w => w.show)" :key="x" class="list-item-container" >
                    <div class="list-item" :style="{ 'grid-template-columns': list.grid }" :id="item._id" :key="item._id">
                        <div v-for="(field,i) in list.fields">
                            <p 
                                :class="(field.class || '')+' ellip'" 
                                @click="fieldClick(field,item,$event)" 
                                v-html="( i == 0 && Array.isArray(item.components) && `<span class='order l-${item.components.length}'></span>` || '' ) +( typeof field.map == 'function' ? field.map(item) : ( item[field.field] || '' ) )"
                                ></p>
                        </div>
                    </div>
                    <component v-for="(component,i) in item.components" :key="i" :is="component" :item="item" @exit="toggleComponent(item)" @editCard="editCard(wallet,item)" @removeCard="removeCard(wallet,item)"></component>
                </div>
            </div>
            <div class="list-items card-box-container" v-if="showICONS">
                <div v-if="Array.isArray(wallet.cards)" v-for="(item,i) in wallet.cards.filter(w => w.show)" :key="i">
                    <div class="card-box">
                        <p>{{ item.title }}</p>
                        <Card :card="item" @removeCard="removeCard(wallet,item)" @editCard="editCard(wallet,item)" />
                        <div v-if="showWallets" class="card-wallets">
                            <div v-for="wallet in item.wallets" class="card-wallet">
                                <p @click="removeFromWallet(wallet,item)">{{ wallet.title }}</p><div class="x"></div>  
                            </div>
                            <p class="btn" @click="addToWallet(item)">add to wallet</p>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div v-if="selectWallet" class="fixed-scroller">
                <div class="v-alert select-wallet">
                    <header><p>Add to Wallet</p><div class="x" @click="selectWallet = false"></div></header>
                    <div class="select-list">
                        <div v-for="wallet in wallets" class="select-item" @click="addCardToWallet(wallet)">
                            <p>{{ wallet.title }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="selectCard" class="fixed-scroller">
                <div class="v-alert select-wallet w-600">
                    <header><p>Add Cards to <span style="font-weight: bold;">{{ wallet.title }}</span></p><p class="btn" @click="updateCards()" style="position: absolute;top: 0px;width: 120px;color: white;line-height: 1.5;right: 60px;margin: 5px;">save</p><div class="x" @click="selectCard = false"></div></header>
                    <div style="display: grid;grid-template-columns: 40px 1fr;">
                        <input type="checkbox" style="margin:6px 10px" @change="showSelectedCards($event)" />
                        <input style="margin: 3px 10px;width: calc(100% - 40px);" @keyup="filterCards($event)" />
                    </div>
                    <div class="select-list">
                        <div v-for="card in cards.filter(c => c.show)" class="select-item" style="display: grid;grid-template-columns: 40px 1fr;"> 
                            <input type="checkbox" v-model="card.selected" style="margin: 0px;background-color: white;" /><p class="ellip" @click="addCardToWallet({ wallet: wallet ,card: card })">{{ card.title }}</p>
                        </div>
                    </div>
                </div>
            </div>
             <!-- 

            <div v-for="card in wallet.cards" class="wallet-card-item">
                <p class="ellip td-ulb" @click="showCard(card)">{{ card.title }}</p>
                <p>{{ format(card.created,'dd/MM/yyyy hh:mm') }}</p>
                <p>{{ format(card.update,'dd/MM/yyyy hh:mm') }}</p>
                <p>{{ card.cat }}</p>
                <p>{{ card.qtyClicks }}</p>
                <p>{{ card.qtyEntries }}</p>
                <p>{{ card.qtyMembers }}</p>
                <p>{{ card.qtyRedeemed }}</p>
                <p>{{ card.expires }}</p>
            </div>

            -->

        </div>
        <component v-for="(component,i) in components" :key="i" :is="component.component" :item="component.item" @exit="toggleComponent(component.item)" @emit="emit" @editCard="editCard(wallet,component.item)" @removeCard="removeCard(wallet,component.item)"></component>
    </div>
</template>

<script>

import { format } from 'date-fns'
import { mapActions, mapMutations } from 'vuex';
import showCards from '../components/showCards.vue'
import Card from '../components/Card.vue'
import Alert from '../utils/Alert.js';
import WebSoc from '../utils/WebSoc.js';
import editVideoCard from '../components/editVideoCard.vue'

export default {
    props: ['item','showWallets'],
    components: {
        showCards,
        Card,
        editVideoCard
    },
    computed: {
        cards () { return this.$store.getters.cards },
        wallets () { return this.$store.getters.wallets }
    },
    created () {
        this.list.grid = this.list.fields.map(f => {
            f.value = '';
            f.order = f.order || '';
            this.list.project[f.field] = 1;
            if ( typeof f.width == 'string' ) return f.width;
            if ( typeof f.width == 'number' ) return f.width + 'px';
            return this.list.width+'px';
        }).join(' ');
    },
    data () {
        return {
            format,
            showICONS: false,
            components: [],
            wallet: {
                cards: []
            },
            card: false,
            selectWallet: false,
            selectCard: false,
            list: {
                grid: '',
                width: 120,
                fields: [
                    { title: 'Title', field: 'title', class: 'td-ulb', width: 270 },
                    { title: 'Created', field: 'created', class: 'ta-r', width: 150, map: item => format(item.created,'dd/MM/yy HH:mm') },
                    { title: 'Updated', field: 'update', class: 'ta-r', width: 150, map: item => format(item.update,'dd/MM/yy HH:mm') },
                    { title: 'Category', field: 'cat', class: 'ta-r', type: 'num', width: 220 },
                    { title: 'Wallets', field: 'wallets', width: '1fr', map: item => { if ( Array.isArray(item.wallets) ) return ('<span class="add"></span>')+item.wallets.map(wallet => '<span class="td-ulb" id="'+wallet._id+'">'+wallet.title+'</span>').join(', '); console.log('!item.wallets',item); return '' } },
                    
                    //{ title: 'Clicks', field: 'qtyClick', class: 'ta-r', type: 'num' },
                    //{ title: 'Entries', field: 'qtyEntries', class: 'ta-r', type: 'num' },
                    //{ title: 'Members', field: 'qtyMembers', type: 'num' },
                    //{ title: 'Sold' },
                    //{ title: 'Revenue' },
                    //{ title: 'Redeemed', field: 'qtyRedeemed' },
                    //{ title: 'Expires', field: 'expires' }
                ],
                project: {}                
            }
        }
    },
    watch: {
        cards ( cards ) {
            if ( this.wallet.title != 'All Cards' ) return;
            console.log('Wqallet List update Cards');
            this.wallet.cards = cards;
        }
    },
    mounted () {
        if ( this.item ) {
            this.wallet = this.item;
        } else {
            console.log('mounted WalletList all cards');
            this.wallet = { title: 'All Cards', cards: this.cards }

        }
    },
    methods: {
        addCardsToWallet ( wallet ) {
            this.cards.forEach(card => {
                this.setObjValue({ obj: card, k: 'show', v: true });
                this.setObjValue({ obj: card, k: 'selected', v: !!wallet.cards.find(c => c == card )});
            });
            this.selectCard = true;
        },
        showSelectedCards ( e ) {
            var checked = e.target.checked;
            this.cards.forEach(card => {
                this.setObjValue({ obj: card, k: 'show', v: checked ? card.selected : true }); 
            });
        },
        filterCards ( e ) {
            var value = e.target.value;
            var text = new RegExp(value.split('* '),'i');
            this.cards.forEach(card => {
                this.setObjValue({ obj: card, k: 'show', v: value ? text.test(card.title) : true });
            });
        },
        updateCards ( e ) {
            var wallet = this.wallet;
            var cards = this.cards.filter(c => c.selected);
            var addCards = cards.filter(c => !wallet.cards.find(card => card._id == c._id));

            var addText = addCards.length > 0 ? '<span style="font-weight:bold;width:100%;line-height:3">Add Cards</span>'+addCards.map(c => '<p>'+c.title+'</p>').join('') : '';
            
            var removeCards = wallet.cards.filter(c => !cards.find(card => card._id == c._id)).filter(c => c); // <span style="font-weight:bold;width:100%;line-height:3">Add Cards</span> // <span style="font-weight:bold;width:100%;line-height:3">Remove Cards</span>
            
            var removeText = removeCards.length > 0 ? '<span style="font-weight:bold;width:100%;line-height:3">Remove Cards</span>'+removeCards.map(c => '<p>'+c.title+'</p>').join('') : '';

            if ( !addText && !removeText ) return Alert.message('No Changes');
            
            Alert.yesno(addText+removeText,yes =>{
                
                if ( !yes ) return;

                this.selectCard = false;
                
                if ( addCards.length > 0 ) {
                    WebSoc.SEND('update',{ DB: 'wallets', _id: wallet._id, update: { $push: { cards: { $each: addCards.map(c => { return { _id: c._id }}) } } } },resp => {
                        console.log('resp',resp);
                    }) 
                }
                if ( removeCards.length > 0 ) {
                    WebSoc.SEND('update',{ DB: 'wallets', _id: wallet._id, update: { $pullAll: { cards: removeCards.map(c => { return { _id: c._id } }) } } },resp => {
                        console.log('resp',resp);
                    })
                }
            })
        },
        newCard () {
            return this.components.push({ t: 'edit-card', component: 'editVideoCard', item: false }); 
        },
        showCard ( card ) {
            console.log('showCard',card);
        },
        addToWallet ( card ) {
            console.log('addToWallet',card);
            console.log('this.selectWallet',this.selectWallet);
            this.card = card;
            this.selectWallet = true;
        },
        removeFromWallet ( wallet, card ) {
            if ( !wallet._id ) {
                console.log('card',card);
                return console.log("!wallet",wallet);
            }
            WebSoc.SEND('update',{ DB: 'wallets', _id: wallet._id, update: { $pull: { cards: { _id: card._id } }}} ,resp => {
                console.log('updated',resp);
                var cards = wallet.cards.length;
                console.log('start',cards);
                var interval = setInterval(() => {
                    console.log(cards,wallet.cards.length,cards != wallet.cards.length);
                    if ( cards != wallet.cards.length ) {
                        clearInterval(interval);
                        this.$forceUpdate()
                    }
                },500);
            })
        },
        addCardToWallet ( wallet, card ) {
            
            console.log('addCardToWallet');

            this.selectWallet = false;
            var card = this.card;
            var current = card.wallets.find(w => w._id == wallet._id);
            if ( current ) return Alert.message('You cannot add the same<br>card twice to a Wallet');
            var length = card.wallets.length;
            WebSoc.SEND('update',{ DB: 'wallets', _id: wallet._id, update: { $push: { cards: { _id: card._id } }}},resp => {
                console.log(length,card.wallets.length);
                var count = 0;
                var interval = setInterval(() => {
                    console.log(length,card.wallets.length);
                    if ( ++count > 40 ) return clearInterval(interval);
                    if ( length != card.wallets.length ) {
                        console.log('gotYa');
                        clearInterval(interval);
                        this.$forceUpdate();
                    } 
                },100)
                this.$forceUpdate();
            });
            
        },
        removeCard ( wallet, card ) {
            console.log('removeCard',card.title,wallet.title);
            Alert.yesno('Remove<br>'+card.title+'<br>from<br>'+wallet.title+'?',yes => {
                if ( !yes ) return;
                if ( !wallet._id ) {
                    var length = this.cards.length;
                    console.log('length',length);
                    return WebSoc.SEND('update',{ DB: 'cards', _id: card._id, update: { $set: { removed: true } } },() => {
                        console.log(length,this.cards.length);
                        this.wallet.cards = this.cards;
                        this.$forceUpdate();
                        if ( this.cards.length != length ) return this.$forceUpdate();
                        forceUpate();
                        var count = 0;
                        var interval = setInterval(() => {
                            console.log(length,this.cards.length);
                            if ( ++count > 40 ) { clearInterval(interval); return console.log('STOP'); }
                            if ( this.cards.length != length ) { this.wallet.cards = this.cards; clearInterval(interval); return this.$forceUpdate(); }
                        },50)
                        this.setObjValue({ obj: card, k: 'components', v: [] });
                    })                   
                }
                var length = wallet.cards.length;
                WebSoc.SEND('update',{ DB: 'wallets', _id: wallet._id, update: { $pull: { cards: { _id: card._id } }}},() => {
                    console.log('removed',card._id);
                    this.setObjValue({ obj: card, k: 'components', v: [] });
                    forceUpate();
                })
            })

            const forceUpate = () => {
                setTimeout(() => {
                        this.$forceUpdate();
                    },2000);
                    setTimeout(() => {
                        this.$forceUpdate();
                    },5000);
                    setTimeout(() => {
                        this.$forceUpdate();
                    },7000);
                    setTimeout(() => {
                        this.$forceUpdate();
                    },11000);
            }
        },
        editCard ( wallet, card ) {
            return this.components.push({ t: 'edit-card', component: 'editVideoCard', item: card });   
        },
        ICONList () {
            this.showICONS = true;
        },
        ItemList () {
            this.showICONS = false;
        },
        emit ( data ) {
            if ( data.action == 'exit' ) {
                this.components = [];
            }
            if ( data.action == 'add-card' ) {
                this.components = [];
                var length = this.cards.length;
                console.log(length,this.cards.length);
                this.$forceUpdate();
                var count = 0;
                var interval = setInterval(() => {
                    console.log(length,this.cards.length);
                    if ( ++count > 30 ) return clearInterval(interval);
                    if ( length != this.cards.length ) {
                        clearInterval(interval);
                        console.log('wallet.cards.length',this.wallet.cards.length);
                        console.log('this.cards.length',this.cards.length);
                        this.wallet.cards = this.cards;
                        this.$forceUpdate();
                    }
                },200);
            }
            console.log('emit data',data);
        },
        toggleComponent ( item ) {
            console.log('toggleComponent',item);
            var v = [];
            if ( item.components.length == 0 ) v.push('showCards');
            this.setObjValue({ obj: item, k: 'components', v })
            this.$forceUpdate();
        },
        order ( field ) {
            console.log('order field',field);
        },
        fieldClick ( field, item , e ) {
            switch ( field.field ) {
                case 'title':
                    return this.toggleComponent(item);
                case 'wallets':
                    if ( e.target.classList.contains('add') ) {
                        this.card = item;
                        this.selectWallet = true;
                        return console.log('add Card to Wallet card',this.card);
                    }
                    var wallet = this.wallets.find(w => w._id == e.target.id)
                    var card = item;
                    return this.removeCard(wallet,card);

            }
            console.log('e.target',e.target);
            console.log('what with',{ field, item });
        },
        search ( e ) {
            var keyCode = e && e.keyCode;
            if ( [9,16,27,38,40].indexOf(keyCode) > -1 ) return;
            clearTimeout(this._search);
            var items = this.wallet.cards; 
            this._search = setTimeout(() => {
                items.forEach(item => {
                    this.setObjValue({ obj: item, k: 'show', v: true })
                });
                this.list.fields.forEach(field => {
                        var p = {};
                        if ( field.order ) {
                            switch ( field.type ) {
                                case 'date':
                                    console.log('sort',field.field,field.order == 'asc' ? -1 : 1)
                                    break;
                                default: 
                                console.log('sort',field.field,field.order == 'asc' ? 1 : -1)
                            }
                            
                        }
                        if ( field.value.length == 0 ) return;

                        if ( field.type == 'num' ) {

                            var val = field.value;
                            var $lt = val.split('<')[1] && parseFloat(val.split('<')[1].split('>')[0]);
                            var $gt = val.split('>')[1] && parseFloat(val.split('>')[1].split('<')[0]);
                            if ( !isNaN($lt) ) { p[field.field] = { $lt: $lt } }
                            if ( !isNaN($gt) ) { p[field.field] = p[field.field] || {}; p[field.field].$gt = $gt; }
                            if ( !p[field.field]   ) { p[field.field] = { $eq: parseInt(val) } }

                        } else {

                            p[field.field] = { $regex: field.value, $options: 'i' }
                        }
                        if ( p[field.field].$regex ) {
                            var text = new RegExp(p[field.field].$regex.split('').join(' *'),'i')

                            switch ( field.field ) {
                                case 'cards':
                                items.forEach(wallet => {
                                    var showWallet = wallet.cards.reduce((p,card) => {
                                        var showCard = text.test(card.title);
                                        this.setObjValue({ obj: card, k: 'show', v: showCard });
                                        return p || showCard;
                                    },false);
                                    this.setObjValue({ obj: wallet, k: 'show', v: showWallet });
                                });
                                break;
                                case 'wallets':
                                items.forEach(card => {
                                    var showCard = card.wallets.reduce((p,wallet) => {
                                        var showCard = text.test(wallet.title);
                                        
                                        return p || showCard;
                                    },false);
                                    this.setObjValue({ obj: card, k: 'show', v: showCard });
                                });
                                break;
                                default:
                                items.forEach((wallet) => {
                                    this.setObjValue({ obj: wallet, k: 'show', v: text.test(wallet[field.field]) })
                                })
                            }

                        }
                    
                        if ( p[field.field].$gt ) {

                        }

                        if ( p[field.field].$lt ) {

                        }

                        if ( p[field.field].$eq ) {

                        }
                  
                })     
            },200);      
        },
        ...mapMutations([
            'setObjValue'
        ]) 
    }
}

</script>

<style lang="scss">
.card-wallets {
float: left;
width: calc(100% - 20px);
margin: 10px;
border: 1px solid #c0c0c0;
.card-wallet {
    position: relative;
    padding: 5px;
    font-weight: bold;
    border-bottom: 1px solid #c0c0c0;
    float: left;
    width: calc(100% - 10px);
    .x { transform: scale(0.5); }
}
.btn {
    margin-top: 20px;
    width: calc(100% - 20px);
}
        }
.wallets,.wallet-list {
    float: left;
    width: calc(100% - 20px);
    .list-items {
        .list-item-container {
            float: left;
            width: 100%;
        }
        &.card-box-container {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            .card-box {
                > p { font-weight: bold; margin-left: 10px; }
                margin: 10px;
            }
        }
    }
}    
.header-search {
    padding: 3px;
    font-size: 20px;
}
.list-icons {
    position: absolute;
    right: 0px;
    top: 2px;
    img {
        margin: 4px 5px;
        &:nth-child(1):active {
            transform: scale(0.9); /* translate(2px,2px); */
        }
        &:nth-child(2):active {
            transform: translate(2px,2px);
        }
    }
} 

.wallet-card-item {
    display: grid;
    grid-template-columns: 300px 200px 200px 90px 90px 90px 90px 90px 130px;
    width: calc(100% - 10px);
    padding: 5px;
    &:nth-child(even) { background-color: rgba(200,200,200,0.4); }
}

</style>